var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-collection-items"},[_c('carousel',{attrs:{"items":_vm.items,"options":_vm.options,"show-navigation":_vm.showNavigation},scopedSlots:_vm._u([{key:"slide",fn:function({ item }){return [_c('div',{staticClass:"about-collection-item"},[_c('img',{attrs:{"src":item.path,"alt":item.title}})])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }